import { jsx as _jsx } from "react/jsx-runtime";
import AddressIcon from '../../components/Common/AddressIcon';
import WalletIconPresentation from './WalletIconPresentation';
export default function WalletIconView(props) {
    return (_jsx(WalletIconPresentation, { ...props, addressIcon: props.wallet.address && (_jsx(AddressIcon, { address: props.wallet.address, size: props.size ?? 24, className: props.className })) }));
}
